module.exports = __webpack_public_path__ + "static/img/enterpriseCertificationSuccess.c4cf48a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/enterpriseCertificationSuccess.png
// module id = ow8f
// module chunks = 2